import { takeLatest, put, call, take } from "redux-saga/effects";

import { EnquiryTypes } from "../Actions/Types/Enquiry";
import { failed } from "../Actions/EnquiryActions";

import * as REST from "../../Services/rest.service";
import { logout } from "../Actions/Auth";
import { TOKEN_EXPIRED } from "../Actions/Types/Auth";

const endPoint = "/enquiry";

const message = "Request Failed!";
let err = new Error(message);
err.status = 500;

const getFranchiseEnquiries = function* (action) {
	try {
		const url = `${endPoint}/franchise`;

		let response = yield call(REST.get(url, action.payload));
		console.log("Response:", response.data);

		if (!response) {
			throw err;
		}
		if (response.status === 200) {
			yield put({ type: action.success, payload: response.data });
		} else if (response.data.status === TOKEN_EXPIRED) {
			yield put(logout());
		} else {
			yield put(failed({ ...response.data }));
		}
	} catch (err) {
		yield put(failed({ err }));
	}
};

const createNewFranchiseEnquiry = function* (action) {
	try {
		const url = `${endPoint}/franchise`;

		let response = yield call(REST.postWithoutAuth(url, action.payload));

		if (!response) {
			throw err;
		}
		if (response.status === 200) {
			yield put({ type: action.success, payload: response.data });
		} else {
			console.log("Failed:", response);
			yield put(failed({ ...response.data }));
		}
	} catch (err) {
		console.log("Error Response:", err.message);
		yield put(failed({ err }));
	}
};

const getContactUsDetails = function* (action) {
	try {
		const url = `${endPoint}/contact-us`;

		let response = yield call(REST.get(url, action.payload));
		console.log("Response:", response.data);
		if (!response) {
			throw err;
		}
		if (response.status === 200) {
			yield put({ type: action.success, payload: response.data });
		} else if (response.data.status === TOKEN_EXPIRED) {
			yield put(logout());
		} else {
			yield put(failed({ ...response.data }));
		}
	} catch (err) {
		yield put(failed({ err }));
	}
};

const createNewContactUs = function* (action) {
	try {
		const url = `${endPoint}/contact-us`;

		let response = yield call(REST.postWithoutAuth(url, action.payload));
		if (!response) {
			throw err;
		}
		if (response.status === 200) {
			yield put({ type: action.success, payload: response.data });
		} else {
			yield put(failed({ ...response.data }));
		}
	} catch (err) {
		yield put(failed({ err }));
	}
};

const getFeedbacks = function* (action) {
	try {
		const url = `${endPoint}/feedback`;

		let response = yield call(REST.get(url, action.payload));

		if (!response) {
			throw err;
		}
		if (response.status === 200) {
			yield put({ type: action.success, payload: response.data });
		} else if (response.data.status === TOKEN_EXPIRED) {
			yield put(logout());
		} else {
			yield put(failed({ ...response.data }));
		}
	} catch (err) {
		yield put(failed({ err }));
	}
};

const createFeedback = function* (action) {
	try {
		const url = `${endPoint}/feedback`;

		let response = yield call(REST.postWithoutAuth(url, action.payload));
		if (!response) {
			throw err;
		}
		if (response.status === 200) {
			yield put({ type: action.success, payload: response.data });
		} else {
			yield put(failed({ ...response.data }));
		}
	} catch (err) {
		yield put(failed({ err }));
	}
};

export function* watchEnquiryRequests() {
	yield takeLatest(EnquiryTypes.GET_FRANCHISE_DETAILS, getFranchiseEnquiries);
	yield takeLatest(
		EnquiryTypes.CREATE_FRANCHISE_ENQUIRY,
		createNewFranchiseEnquiry
	);
	yield takeLatest(EnquiryTypes.GET_CONTACT_US_DETAILS, getContactUsDetails);
	yield takeLatest(EnquiryTypes.CREATE_CONTACT_US, createNewContactUs);

	yield takeLatest(EnquiryTypes.GET_FEEDBACKS, getFeedbacks);
	yield takeLatest(EnquiryTypes.CREATE_FEEDBACK, createFeedback);
}
